<template>
  <div class="pa-section pa-section-service-unavailable">
    <p class="pa-head">システム調整</p>
    <hr class="pa-separator" />

    <p class="pa-text pa-text-1">異界舞踏会・アキバトリカルはシステム調整のため一時的にご利用頂くことができません。</p>
    <p class="pa-text pa-text-2">恐れ入りますが、再演まで今暫くお待ちください。</p>

    <button
     class="button pa-reconnecting-button"
     :class="additionalReconnectingButtonClass"
     :disabled="isDisableReconnectingButton"
     @click.prevent="handleClickReconnectingButton"
    >再演を確認する</button>

    <div class="pa-status-box" v-if="hasReopenInfomation">
      <div class="title-box">
        <hr class="title-separator" />
        <p class="pa-text pa-title">再演情報</p>
        <hr class="title-separator" />
      </div>
      <p class="pa-text pa-text-date">異世界地球時間{{reopenInfomation.update_at | mutateUnavailableDate}}更新</p>
      <p class="pa-text pa-text-strong">異界舞踏会・アキバトリカルは異世界地球時間{{reopenInfomation.reopen_at | mutateUnavailableDate}}の再演を予定致しております。</p>
    </div>

    <p class="pa-credit">２４区番外地管理局</p>
  </div>
</template>

<script>
import FrontPageMixins      from '@/mixins/FrontPageMixins'

export default {
  mixins : [
    FrontPageMixins
  ],

  data(){
    return {
      hasReopenInfomation : false,

      // reopenInfomation    : {
      //   reopen_at : '2020-05-10 00:00:00',
      //   update_at : '2020-05-05 11:11:11',
      // },
      reopenInfomation    : {
        reopen_at : null,
        update_at : null
      },

      isLoadingReconnectingButton       : false,
      additionalReconnectingButtonClass : {
        'is-loading'  : false
      },
      isDisableReconnectingButton       : false,

      couldHelthCheckInterval           : 30,
      lastHelthCheckDate                : null,
    };
  },

  computed : {
    homePath(){
      return this.$store.state.requests.auth.paths.webApi.home;
    }
  },

  watch : {
    reopenInfomation : {
      handler(data){
        if(data.update_at !== null){
          this.hasReopenInfomation = true;
        }
      },
      immediate: true,
      deep: true
    },
    
    isLoadingReconnectingButton : {
      handler(value){
        this.additionalReconnectingButtonClass['is-loading'] = value;
        this.isDisableReconnectingButton = value;
      }
    }
  },

  methods : {
    async healthCheck(){
      const result = await this.$store.dispatch({
        type        : 'requests/apiRequest',
        method      : 'get',
        requestPath : this.homePath,
      }, {root: true});

      // set last helth check date
      this.lastHelthCheckDate = this.$moment();

      if(result.status === 200){
        this.$router.push({ name: 'home' });
      }else if(result.status === 401){
        this.$router.push({ name: 'index' });
      }

      return result.status;
    },

    async handleClickReconnectingButton(){
      this.isLoadingReconnectingButton = true;

      await this.UXWaiting(1000);

      let status = 503;

      if( this.checkCouldTryHelthCheck() ){
        status = await this.healthCheck();
      }

      if(status !== 200 && status !== 401){
        this.$store.dispatch({
          type        : 'flashMessage/updateFlashMessage',
          hasMessage  : true,
          message     : '&nbsp;申し訳ございません。再演まで今暫くお待ちくださいませ。',
          status      : 'error',
          hasControl  : true,
          autoClose   : false
        }, {root:true});
      }

      this.isLoadingReconnectingButton = false;
    },

    checkCouldTryHelthCheck(){
      const diffSec = this.$moment().diff(this.lastHelthCheckDate, 'seconds');

      if(diffSec > this.couldHelthCheckInterval){
        return true;
      }else{
        return false;
      }
    }
  },

  async mounted(){
    this.$on('mountedPage', () => {
      this.healthCheck();
    });

    await this.initializePage({
      allowFullAccess : true
    });
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

.pa-section{
  &-service-unavailable{
    position: relative;
    box-sizing: border-box;
    width:98%;
    min-height:320px;
    margin:2rem auto;
    max-width: 540px;
    background-color: #CAB090;
    border:4px solid #89620C;
    border-radius: 8px;
    padding-bottom: 2.2rem;

    p.pa-head{
      font-size:1.4rem;
      text-align: center;
      padding:.5rem 0 .3rem;
      color:#513F28;
    }

    hr.pa-separator{
      display: block;
      width:90%;
      margin:0 auto;
      height:2px;
      border: 0;
      background-color: #AE9679;
      margin-bottom:.5rem;
    }

    p.pa-text{
      text-align: center;
      color:#513F28;
      font-size:.9rem;
      line-height: 1.7;
      padding:0 1rem;

      &-2{
        margin:.4rem 0;
        padding:0 .7rem;
      }
    }

    button.pa-reconnecting-button{
      display: block;
      width:50%;
      margin:0 auto;
      border-radius: 5px;
      background-color: #C49065;
      border:2px solid #A4734B;
      color: #5E3717;
      text-align: center;
      font-size:1rem;
      line-height: 1rem;
      padding:.5rem .3rem;
      height:inherit;

      @include until(375px) {
        font-size:1rem;
        line-height: 1rem;
      }

      &.is-loading{
        background-color: #B9916F;
        border-color: #B58A68;
      }

      &.is-loading::after{
        border: 1.3px solid #6C482B;
        border-right-color: transparent;
        border-top-color: transparent;
      }

      &:disabled{
        background-color: #C49065;
        border:2px solid #A4734B;
      }

      &:active, &:hover, &:focus, .is-focused{
        border-color: #A4734B;
        color: #5E3717;
      }
    }

    p.pa-credit{
      position: absolute;
      bottom:.4rem;
      right:1rem;
      color:#513F28;
      font-size:1.1rem;
    }

    .pa-status-box{
      width:90%;
      margin:1rem auto;
      background-color: #C6AB8A;
      padding-bottom:.4rem;

      p.pa-text{
        font-size:.75rem;
        color:#6C5D4A;

        &-strong{
          color:#645644;
        }
      }

      div.title-box{
        padding-top:.4rem;
        position: relative;
        display: flex;
        justify-content: center;

        p.pa-text.pa-title{
          padding:0 .3rem;
          font-size:1rem;
        }

        hr.title-separator{
          display: block;
          margin:0;
          width:12px;
          height:2px;
          background-color:#6C5D4A;
          border-radius: 8px;
          margin-top:.72rem;
        }
      }

      p.pa-text-date{
        margin:.3rem 0;
        font-size: .7rem;
        text-decoration: underline;
      }
    }
  }
}
</style>